import NProgress from "nprogress"
import "nprogress/nprogress.css"

NProgress.configure({
  trickleSpeed: 800,
  showSpinner: false,
  speed: 800
})

export default NProgress
